import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { msLoginThunk } from "../../store/auth/thunkMiddlewares";
import { useAppDispatch } from "../../store/hooks";

const MicrosoftCallBackSignPage = () => {
  let { search } = useLocation();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    const query = new URLSearchParams(search);
    const authorizationCode = query.get("code");
    dispatch(msLoginThunk(authorizationCode!, navigate));
  }, []);
  return <div></div>;
};

export default MicrosoftCallBackSignPage;
